import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown, Icon } from "semantic-ui-react";

import { useDealerAndLocationsGroupedOptions, usePermanentLocations, usePermanentRealtimeDealers } from "components";
import { typedQueryClient } from "hooks";
import "modules/LocationLicenseOverview/components/LocationLicenseFilters/components/LocationDropdown/LocationLicenseLocationDropdown.scss";
import { useLocationLicensesDashboardFilters } from "modules/LocationLicenseOverview/components/LocationLicenseFilters/hooks";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { LOCATION_LICENSES_STORAGE_KEYS } from "modules/LocationLicenseOverview/storageKeys";
import { setPreference } from "utils/common";

// TODO: remove this component, use the same component as we have in the header on other pages
export const LocationDropdown = () => {
  const { t } = useTranslation();

  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const { dealers } = usePermanentRealtimeDealers();
  const { locations } = usePermanentLocations();
  const { dealer: selectedDealer, location: selectedLocation } = useLocationLicensesDashboardFilters();
  const dealerAndLocationsGroupedDropdownOptions = useDealerAndLocationsGroupedOptions({ searchTerm, selectAll: false });

  const handleLocationChange = (locationId: number) => {
    const location = locations.find(loc => loc.id === locationId);
    const dealer = dealers.find(d => location?.dealer_id === d.id);

    setPreference(LOCATION_LICENSES_STORAGE_KEYS.DealerPreference, dealer || null);
    setPreference(LOCATION_LICENSES_STORAGE_KEYS.LocationPreference, location || null);
    typedQueryClient.setQueryData(LocationLicenseOverviewKeys.filters, { dealer: dealer || null, location: location || null });
  };

  const handleCloseDropdown = () => {
    setSearchTerm("");
    setShowDropdown(false);
  };

  const handleDropdownItemClick = (locationId: string) => {
    handleLocationChange(parseInt(locationId.split("-").at(1) ?? "0"));
    handleCloseDropdown();
  };

  return (
    <div className="LocationLicenseLocationDropdown">
      <Dropdown
        fluid
        selection
        search
        scrolling
        open={showDropdown}
        searchQuery={searchTerm}
        value={"location-" + selectedLocation?.id}
        options={dealerAndLocationsGroupedDropdownOptions}
        selectOnBlur={false}
        onClose={handleCloseDropdown}
        onClick={() => setShowDropdown(true)}
        noResultsMessage={t("v8_no_locations", "No locations")}
        onSearchChange={(_, data) => setSearchTerm(data.searchQuery)}
        placeholder={selectedDealer && selectedLocation ? `${selectedDealer.name} - ${selectedLocation.name}` : t("v8_select_location", "Select a location")}
        trigger={
          selectedLocation &&
          selectedDealer &&
          !searchTerm && (
            <span className={showDropdown ? "placeholder-text-color" : "selected-text-color"}>
              {selectedDealer.name} - {selectedLocation.name}
            </span>
          )
        }
      >
        <Dropdown.Menu>
          {dealerAndLocationsGroupedDropdownOptions.map(option => (
            <Dropdown.Item
              key={option.key}
              active={"location-" + selectedLocation?.id === option.value}
              disabled={option.disabled}
              className={`locationItem ${option.isLastLocation ? "last-location-item" : ""}`}
              onClick={e => {
                e.stopPropagation();
                handleDropdownItemClick(option.value);
              }}
            >
              <Icon className={option.icon} />
              <span className={option.icon === "house" ? "dealer-dropdown-option" : ""}>{option.text}</span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
